/**
 * Created by Administrador on 24/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('baseRates', {
                parent: 'app',
                url: '/baseRates',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "10"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRate/baseRates.html',
                        controller: 'baseRatesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            baseRates: ['baseRateService','$stateParams',function(baseRateService,$stateParams){
                                return baseRateService.getBaseRates($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('baseRateEdit', {
                parent: 'app',
                url: '/baseRate/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRate/baseRateEdit.html',
                        controller: 'baseRateEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            baseRate: ['baseRateService','$stateParams', function(baseRateService,$stateParams){
                                return baseRateService.getBaseRate($stateParams.id);
                            }]
                        }
                    }
                }
            });
    }
})();
